export enum Steps {
  INFORMATIONAL = "Informational",
  MEMBER_PLAN_SOURCE = "MemberPlanSource",
  MEMBER_COVERAGE_TYPE = "MemberCoverageType",
  MEMBER_HSA_INDIVIDUAL = "MemberHSA_INDIVIDUAL",
  MEMBER_HSA_FAMILY = "MemberHSA_FAMILY",
  MEMBER_HAS_LEGAL_PARTNER = "MemberHasLegalPartner",
  PARTNER_PLAN_SOURCE = "PartnerPlanSource",
  PARTNER_PLAN_SOURCE_ACA = "PartnerPlanSourceACA",
  PARTNER_COVERAGE_TYPE = "PartnerCoverageType",
  PARTNER_HAS_HSA = "PartnerHasHSA",
  PROCESS_MEMBER_ENROLLMENT = "ProcessMemberEnrollment",
  TALK_TO_CARROT = "TalkToCarrot",
  INFO_CONNECT_INSURANCE = "InformationalConnectInsurance",
  SKIP_CONNECT_INSURANCE = "SkipConnectInsurance",
  PROVIDER_CONNECT = "ProviderConnect",
  DOB_SEX_CONNECT = "DobSexConnect",
  CONNECT_PROVIDER_NOT_LISTED = "ConnectProviderNotListed",
  PROCESS_CONNECT_INSURANCE = "ProcessConnectInsurance",
  PROCESS_CONNECT_INSURANCE_SUCCESS = "ProcessConnectInsuranceSuccess",
  PROCESS_CONNECT_INSURANCE_FAIL = "ProcessConnectInsuranceFail",
  CONNECT_INSURANCE_NOT_REQUIRED = "ConnectInsuranceNotRequired",
  UNKNOWN_ERROR = "UnknownError"
}
